import { render } from "./AgenteJornadaReportarIncidencia.vue?vue&type=template&id=1829712a&scoped=true"
import script from "./AgenteJornadaReportarIncidencia.vue?vue&type=script&lang=ts"
export * from "./AgenteJornadaReportarIncidencia.vue?vue&type=script&lang=ts"

import "./AgenteJornadaReportarIncidencia.vue?vue&type=style&index=0&id=1829712a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1829712a"

export default script